import { ApiResponse, PaginatedApiResponse } from '@/types/api.types';
import baseApi from './RootBaseApi';
import {
  IPoiRequest,
  PoiRequestsListResponse,
  PoiRequestListQueryParams,
  PoiRequestUpdateData,
} from '@/types/poi-request-management.types';

export const PoiRequestManagementService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPoiRequests: builder.query<
      PaginatedApiResponse<IPoiRequest[]>,
      PoiRequestListQueryParams
    >({
      query: (params) => ({
        url: '/poi-requests',
        method: 'GET',
        params,
      }),
      transformResponse: (response: PoiRequestsListResponse) => ({
        data: response.data,
        totalItems: response.total,
        totalPages: response.totalPages,
        currentPage: response.page,
        status: response.status,
        message: response.message,
      }),
      providesTags: ['PoiRequests'],
      keepUnusedDataFor: 0,
    }),

    updatePoiRequest: builder.mutation<
      ApiResponse<IPoiRequest>,
      { id: string; data: PoiRequestUpdateData; harborId?: string | null }
    >({
      query: ({ id, data, harborId }) => ({
        url: `/poi-requests/${id}${harborId ? `?harborId=${harborId}` : ''}`,
        method: 'PATCH',
        data: data,
      }),
      invalidatesTags: ['PoiRequests'],
    }),

    approveAndCreatePoi: builder.mutation<
      ApiResponse<unknown>,
      { id: string; data: FormData; harborId?: string | null }
    >({
      query: ({ id, data, harborId }) => ({
        url: `/poi-requests/${id}/approve${harborId ? `?harborId=${harborId}` : ''}`,
        method: 'PUT',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      invalidatesTags: ['PoiRequests', 'POIs'],
    }),

    updatePoiRequestStatus: builder.mutation<
      ApiResponse<IPoiRequest>,
      { id: string; data: { status: string; reason?: string }; harborId?: string | null }
    >({
      query: ({ id, data, harborId }) => ({
        url: `/poi-requests/${id}/status${harborId ? `?harborId=${harborId}` : ''}`,
        method: 'PATCH',
        data: data,
      }),
      invalidatesTags: ['PoiRequests'],
    }),
  }),
});

export const {
  useGetPoiRequestsQuery,
  useUpdatePoiRequestMutation,
  useApproveAndCreatePoiMutation,
  useUpdatePoiRequestStatusMutation,
} = PoiRequestManagementService;
